/* eslint-disable react/destructuring-assignment */

import React, { Component } from 'react';
import { EmailTemplateViewModel } from 'stageclip-common';

import { ModalContainer } from '../guardedModal/ModalContainer';

import { fetchEmailTemplate, updateClient } from 'api/clients/clients.actions';
import AppModal from 'components/modal/appModal';
import { PreviewTemplate } from './previewTemplate/previewTemplate';

type EmailTemplateModalContentState = {
  data: EmailTemplateViewModel | null;
  error: boolean;
};

export class EmailTemplateModalContent extends Component<any, EmailTemplateModalContentState> {
  constructor(props: EmailTemplateModalContent) {
    super(props);

    this.state = {
      data: null,
      error: null,
    };
  }

  componentDidMount(): void {
    const { dispatch, clientId } = this.props;

    dispatch(fetchEmailTemplate(clientId) as any)
      .then(({ payload }: { payload: EmailTemplateViewModel }) => this.setState({ data: payload }))
      .catch(() => this.setState({ error: true }));
  }

  markAsRead = () => {
    const { dispatch, clientId, onClose } = this.props;

    dispatch(updateClient(clientId, { emailUpdated: false }))
      .then(({ payload }: any) => {
        onClose(payload);
      })
      // eslint-disable-next-line no-console
      .catch(console.error);
  };

  render() {
    const { data, error } = this.state;
    const { id } = this.props;

    return (
      // @ts-ignore
      <AppModal id={id} title="Email template" hideOpenButton closeButtonLabel="Mark as read" onClose={this.markAsRead}>
        {!!error && <div>Email template is not created</div>}
        {!error && (!!data || <div>loading</div>)}
        {!error && !!data && <PreviewTemplate initialValues={data} form={id} />}
      </AppModal>
    );
  }
}

type EmailTemplateModalProps = { onClose: (response: any) => void };

export const EmailTemplateModal = (props: EmailTemplateModalProps) => {
  const { onClose } = props;

  return (
    <ModalContainer id="email-template-modal">
      <EmailTemplateModalContent onClose={onClose} />
    </ModalContainer>
  );
};
